import { setPrivTags } from '@helpers/privilege.helper';
import { get } from './api.service';
import { URL_PRIVILEGE } from '@constants/api.constants';
import { IPrivilege } from '@interfaces/privilege';

const endpointPrivilege = URL_PRIVILEGE;

export const getListPrivileges = (merchantId: string) => {
	return get(`${endpointPrivilege}/merchant/${merchantId}/active-privilege`).then((privileges) => {
		privileges?.data.forEach((priv: IPrivilege) => setPrivTags(priv));
		return privileges;
	});
};

export const getPrivilegeById = (pId: string) => {
	return get(`${endpointPrivilege}/${pId}`).then((privilege) => {
		privilege.data = setPrivTags(privilege.data);
		return privilege;
	});
};
